// Import the generated route tree
import { routeTree } from './routeTree.gen';
import {createRouter} from "@tanstack/react-router";

// Create a new router instance
const router = createRouter({ routeTree });

export default router